import { Table } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getColumns } from './config';
import { Style } from '../../additional-subjects/table/list';
import { getLocales } from "../../../../../../Table/newTable";

export default function List({
  onChange = () => { },
  items = [],
  value = [],
  search = '',
  hasInfoShared = true,
}) {
  const { t } = useTranslation();
  const dataSource = useMemo(() => {
    const _items = search ? items.filter((it) => (
      (it.sourceName || '').toLowerCase().indexOf(search.toLowerCase()) !== -1
    )) : items;
    return _items.map((it) => ({
      ...it,
      key: it.id,
    }));
  }, [items, search]);

  const _onChangeSelected = (val) => {
    const isUnselect = !!value.find((i) => i === val.id);

    if (isUnselect) {
      onChange(value.filter((v) => v !== val.id));
    } else {
      onChange([...value, val.id]);
    }
  };

  const columns = useMemo(() => (
    getColumns({ t, hasInfoShared })
  ), [t]);

  return (
    <Style>
      <div className="flex-1 flex-c extra-small small-body daf-table-wrapper no-pagination">
        <Table
          locale={getLocales(t)}
          size="small"
          columns={columns}
          dataSource={dataSource}
          rowSelection={{
            selectedRowKeys: value,
            onSelect: _onChangeSelected,
            hideSelectAll: true,
          }}
          scroll={{ y: 282 }}
          pagination={false}
        />
      </div>
    </Style>
  )
}

